module.exports = __webpack_public_path__ + "cdbc734722e21176fafc6644431586b0.svg";